import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './Reducer'
import rootSaga from './Rootsaga'

const getDefaultRootState = () => rootReducer(undefined, { type: "@@INIT" });

const mergePreloadedState = (preloadedState = {}) => {
  const defaultState = getDefaultRootState();

  return Object.keys(defaultState).reduce((mergedState, sliceKey) => {
    const defaultSlice = defaultState[sliceKey];
    const preloadedSlice = preloadedState[sliceKey];

    if (preloadedSlice === undefined) {
      mergedState[sliceKey] = defaultSlice;
      return mergedState;
    }

    if (
      defaultSlice &&
      typeof defaultSlice === "object" &&
      !Array.isArray(defaultSlice) &&
      preloadedSlice &&
      typeof preloadedSlice === "object" &&
      !Array.isArray(preloadedSlice)
    ) {
      mergedState[sliceKey] = {
        ...defaultSlice,
        ...preloadedSlice,
      };
      return mergedState;
    }

    mergedState[sliceKey] = preloadedSlice;
    return mergedState;
  }, {});
};

export const createAppStore = (preloadedState = {}) => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    preloadedState: mergePreloadedState(preloadedState),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
  });

  sagaMiddleware.run(rootSaga);
  return store;
};

const store = createAppStore();

export default store
